import BybVrCard from "@Components/common/byb-ds/cards/byb-vr-card";
import { Day } from "@Components/game/progress/stats/styled-components";
import TimeDisplay from "@Components/game/progress/stats/time-display";
import { useProgress } from "@Context/game/progress/progress-context";
import useI18n from "@i18n";
import { Grid, Stack, Typography } from "@mui/material";
import dayjs from "dayjs";

interface IMonthlyTraining {}

const MonthlyTraining = ({}: IMonthlyTraining) => {
  const { monthlyDailyStats } = useProgress();
  const { i18n } = useI18n();

  const currentMonth = dayjs();
  const totalDays = currentMonth.daysInMonth();
  const firstDayOfMonth = currentMonth.startOf("month").day();

  const sessionDateSet = new Set(monthlyDailyStats.filter(session => session.updated_at).map(session => dayjs(session.updated_at).date()));

  const activeDaysCount = sessionDateSet.size;

  const emptyDays = Array.from({ length: firstDayOfMonth }, (_, index) => ({
    day: 0,
    isActive: false,
    isInMonth: false,
  }));

  const calendarDays = Array.from({ length: totalDays }, (_, index) => {
    const dayNumber = index + 1;
    const hasActivity = sessionDateSet.has(dayNumber);

    return {
      day: dayNumber,
      isActive: hasActivity,
      isInMonth: true,
    };
  });

  const allDays = [...emptyDays, ...calendarDays];

  return (
    <BybVrCard sx={{ width: "100%", height: "100%" }}>
      <Stack width="100%" gap={2} height="100%">
        <Stack gap={1} width="100%" justifyContent="space-between">
          <Typography variant="text1xl400" color="text.secondary" textAlign="left">
            {i18n("progress.training.monthly")}
          </Typography>
          <TimeDisplay days={activeDaysCount} />
        </Stack>
        <Grid container spacing={1}>
          {allDays.map((day, index) => (
            <Grid item key={index} xs={12 / 7}>
              <Day isInMonth={day.isInMonth} isActive={day.isActive} />
            </Grid>
          ))}
        </Grid>
      </Stack>
    </BybVrCard>
  );
};

export default MonthlyTraining;
